<template>
  <div class="container">
    <!-- <div class="header">
      <span>服务器机组1</span>
    </div> -->
    <!-- 改变风扇dialog -->
    <el-dialog
      title="调节风扇转速"
      :visible.sync="fansDialogVisible"
      width="40%"
    >
      <h1>档位调节</h1>
      <el-row>
        <el-button
          type="info"
          plain
          style="width: 80px"
          @click="changeFanSpeedByNum(0)"
        >0档</el-button>
        <el-button
          plain
          style="width: 80px"
          @click="changeFanSpeedByNum(1)"
        >1档</el-button>

        <el-button
          type="primary"
          style="width: 80px"
          plain
          @click="changeFanSpeedByNum(2)"
        >2档</el-button>

        <el-button
          type="success"
          style="width: 80px"
          plain
          @click="changeFanSpeedByNum(3)"
        >3档</el-button>

        <el-button
          type="warning"
          style="width: 80px"
          plain
          @click="changeFanSpeedByNum(4)"
        >4档</el-button>
        <el-button
          type="danger"
          style="width: 80px"
          plain
          @click="changeFanSpeedByNum(5)"
        >5档</el-button>
      </el-row>
      <h1>指定转速</h1>
      <el-row>
        <el-input
          placeholder="请输入0-255之间的风扇转速 "
          style="width: 80%"
          v-model="chosedSpeed"
        >

        </el-input>
        <el-button
          type="primary"
          @click="changeFanSpeedByChosedSpeed()"
        >提交</el-button>
      </el-row>

    </el-dialog>

    <!-- 结束风扇dialog -->
    <div class="topcards">
      <div class="topcard">
        <div class="topcard-title">
          服务器数量
        </div>
        <div class="topcard-content">
          <div class="card-icon"><img
              src="@/assets/服务器.svg"
              class="card-icon-img"
            ></div>
          <div class="card-icon-font">{{ipList.length  }}</div>
        </div>
      </div>
      <div class="topcard">
        <div class="topcard-title">
          服务器温度
        </div>
        <div class="topcard-content">
          <div class="card-icon"><img
              src="@/assets/温度.svg"
              class="card-icon-img"
            ></div>
          <div class="card-icon-font">{{cardList.temp}}</div>
        </div>
      </div>
      <div class="topcard">
        <div class="topcard-title">
          风扇转速
        </div>
        <div class="topcard-content">
          <div class="card-icon"><img
              src="@/assets/风扇.svg"
              class="card-icon-img"
            ></div>
          <div class="card-icon-font">{{ cardList.speed }}</div>
        </div>
      </div>
      <div class="topcard">
        <div class="topcard-title">
          运行时长
        </div>
        <div class="topcard-content">
          <div class="card-icon"><img
              src="@/assets/时钟.svg"
              class="card-icon-img"
            ></div>
          <div class="card-icon-font">{{ cardList.min}}h</div>
        </div>
      </div>
    </div>
    <div class="charts-container">
      <div
        class="chart"
        v-for="(item,index) in ipList"
        :key="index"
      >
        <div class="topcard-title">
          <div class="header-1"><img
              src="@/assets/online.svg"
              width="40px"
            />
            服务器{{item.ip}}</div>
          <div class="buttons">
            <el-button
              type="success"
              size="small"
              icon="el-icon-data-line"
              class="detail"
              @click="showDetail(item.ip)"
            >显示详细信息</el-button>
            <el-button
              size="small"
              type="warning"
              icon="el-icon-magic-stick"
              class="auto"
              @click="autoChange(item.ip,index)"
            >{{ipList[index].status || '更改模式'}}</el-button>
            <!-- <el-input
              v-model="fanspeed[index]"
              class="put-input"
            ></el-input> -->
            <el-button
              size="small"
              type="primary"
              class="put-button"
              @click="changeFanSpeed(item.ip,index)"
            >改变风扇转速</el-button>
          </div>
        </div>
        <div class="chart-item">
          <TempCharts :ip="item.ip"></TempCharts>
        </div>
      </div>
      <div
        class="chart"
        style="display:none;"
      >
        <div class="topcard-title">
          <div class="header-1"><img
              src="@/assets/online.svg"
              width="40px"
            />
            服务器1</div>
          <div class="buttons">
            <el-button
              type="success"
              size="small"
              icon="el-icon-data-line"
              class="detail"
              @click="$message.success('此服务器仅供展示，无法显示！')"
            >显示详细信息</el-button>
            <el-button
              size="small"
              type="warning"
              icon="el-icon-magic-stick"
              class="auto"
              @click="$message.success('此服务器仅供展示，无法显示！')"
            > 更改模式</el-button>
            <!-- <el-input
              v-model="fanspeed[index]"
              class="put-input"
            ></el-input> -->
            <el-button
              size="small"
              type="primary"
              class="put-button"
              @click="$message.success('此服务器仅供展示，无法更改！')"
            >改变风扇转速</el-button>
          </div>
        </div>
        <div class="chart-item">
          <TempCharts2></TempCharts2>
        </div>
      </div>
    </div>
    <el-dialog
      :title="`服务器${dialog.ip}`"
      :visible.sync="dialogVisible"
      width="80%"
      class="dialog1"
    >
      <div
        class="dialog-container"
        slot='footer'
      >
        <div class="dialog-chart">
          <el-card
            class="dialog-card"
            id="card1"
            slot='footer'
          >
            <div
              id="card-1"
              class="card-"
            ></div>
          </el-card>
        </div>
        <div class="dialog-chart">
          <el-card
            class="dialog-card"
            id="card2"
            slot='footer'
          >
            <div
              id="card-2"
              class="card-"
            ></div>
          </el-card>
        </div>
        <div class="dialog-chart">
          <el-card
            class="dialog-card"
            id="card3"
            slot='footer'
          >
            <div
              id="card-3"
              class="card-"
            ></div>
          </el-card>
        </div>
        <div class="dialog-chart">
          <el-card
            class="dialog-card"
            id="card4"
            slot='footer'
          >
            <div
              id="card-4"
              class="card-"
            ></div>
          </el-card>
        </div>
        <div class="dialog-chart">
          <el-card
            class="dialog-card"
            id="card5"
            slot='footer'
          >
            <div
              id="card-5"
              class="card-"
            ></div>
          </el-card>
        </div>
        <div class="dialog-chart">
          <el-card
            class="dialog-card"
            id="card6"
            slot='footer'
          >
            <div
              id="card-6"
              class="card-"
            ></div>
          </el-card>
        </div>

      </div>
    </el-dialog>
  </div>

</template>

<script>
import TempCharts from '@/components/Charts/TempCharts'
import $ from 'jquery'
import TempCharts2 from '@/components/Charts/TempCharts2'
import * as echarts from 'echarts'
export default {
  name: 'MyMenu',
  data () {
    return {
      chosedSpeed: '',
      fansDialogVisible: false,
      activeIP: '',
      frameId: '',
      dialog: {
        ip: [],
        percent: [],
        temp: [],
        power: [],
        date: [],
        fanspeed: [],
        Mfree: [],
        MPercent: [],
        Mtotal: [],
        Mused: []

      },
      cardList: {
        total: 0,
        temp: 0,
        speed: 0,
        min: 0
      },
      tempList: [],
      dialogVisible: false,
      fanspeed: [],
      autoColor: [],
      fanspeedshow: '1800',
      ipList: [],
      fanspeed1: '',
      checkSpeed: { type: 'number', min: 0, max: 266, message: '大小要在0到255', trigger: 'blur' },
      optionFanSpeed: {
        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 0,
          max: 1800
        },
        title: {
          left: 'center',
          text: '风扇转速监测 '
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          // data: this.create_time
          data: []
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          // data: this.temp
          data: []
        }
      },
      optionPercent: {
        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 0,
          max: 100
        },
        title: {
          left: 'center',
          text: 'CPU占用率监测 '
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          // data: this.create_time
          data: []
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          // data: this.temp
          data: []
        }
      },
      optionPower: {
        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 20,
          max: 50
        },
        title: {
          left: 'center',
          text: 'CPU功率监测 '
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          // data: this.create_time
          data: []
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          // data: this.temp
          data: []
        }
      },
      optionMfree: {
        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 0,
          max: 100
        },
        title: {
          left: 'center',
          text: '内存可用'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          // data: this.create_time
          data: []
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          // data: this.temp
          data: []
        }
      },
      optionMPercent: {
        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 20,
          max: 120
        },
        title: {
          left: 'center',
          text: '内存占用百分比 '
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          // data: this.create_time
          data: []
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          // data: this.temp
          data: []
        }
      },
      optionMused: {
        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 20,
          max: 120
        },
        title: {
          left: 'center',
          text: '内存已使用量 '
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          // data: this.create_time
          data: []
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          // data: this.temp
          data: []
        }
      }
    }
  },
  methods: {
    async changeFanSpeed (item, index) {
      // var that = this
      // if (this.fanspeed[index] < 0 || this.fanspeed[index] > 255 || !this.fanspeed[index]) {
      //   this.$message.error('更改失败，转速要在0-255之内！')
      // } else {
      //   $.ajax({
      //     type: 'post', // 方式
      //     url: 'http://110.40.152.26:9016/speed', // 后台处理数据的地址
      //     data: { speed: this.fanspeed[index], userIp: item }, // 传输的数据
      //     success: function (data) {
      //       // 数据成功，插入数据库成功与否的返回值
      //       that.$message.success('更改成功')// 数据发生错误
      //     },
      //     error: function (data) {
      //       that.$message.error('更改失败，接口错误')// 数据发生错误
      //     }
      //   })
      // }
      console.log(item)
      this.fansDialogVisible = true
      this.activeIP = item
    },
    async getCard () {
      const { data: res } = await this.$http.get('card')
      this.cardList = res
      // console.log(res)
      // this.fanspeedshow = res
    },
    async getIpList () {
      const { data: res } = await this.$http.post(`/frame/exitIps/${this.frameId}`)
      // console.log(res)
      // for (const item in res) {
      //   this.ipList.push({ ip: res[item] })
      // }
      res.data.forEach(item => {
        this.ipList.push({ ip: item.ip })
      })
    },
    autoChange (ip, index) {
      var that = this
      this.$prompt('此操作可能不适配于你的机型，可能导致不可逆的硬件损伤，你可以联系我们适配或者继续使用,继续使用请输入‘我已知悉’', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        if (value !== '我已知悉') {
          this.$message({
            type: 'error',
            message: '请输入我已知悉！'
          })
        } else {
          $.ajax({
            type: 'post', // 方式
            url: 'http://110.40.152.26:9016/AI', // 后台处理数据的地址
            data: { userIp: ip }, // 传输的数据
            success: function (data) {
              // 数据成功，插入数据库成功与否的返回值
              data = JSON.stringify(data)

              if (data === '"0"') {
                that.$message.success('更改成功,当前模式：手动模式')// 数据发生错误
                that.ipList[index].status = '手动模式'
                that.$forceUpdate()
              } else if (data === '"1"') {
                that.$message.success('更改成功,当前模式：智能模式')// 数据发生错误
                that.ipList[index].status = '智能模式'
                that.$forceUpdate()
              }
            },
            error: function (data) {
              that.$message.error('更改失败，接口错误')// 数据发生错误
            }
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作'
        })
      })
      this.$forceUpdate()
    },
    async showDetail (ip) {
      this.dialogVisible = true
      this.dialog.ip = ip
      this.initCharts()
      setInterval(this.postChart, 2000)
    },
    async postChart () {
      const { data: res } = await this.$http.post('realCpuAndMem', `ip=${this.dialog.ip}`)

      this.tempList = res
      this.dialog.date = []
      this.dialog.fanspeed = []
      this.dialog.percent = []
      this.dialog.power = []
      this.dialog.Mfree = []
      this.dialog.MPercent = []
      this.dialog.Mtotal = []
      this.dialog.Mused = []
      for (const i in this.tempList.cpu) {
        this.dialog.date.push(this.tempList.cpu[i].create_time)
        this.dialog.fanspeed.push(this.tempList.cpu[i].fanSpeed)
        this.dialog.percent.push(this.tempList.cpu[i].percent)
        this.dialog.power.push(this.tempList.cpu[i].power)
        this.dialog.Mfree.push(this.tempList.mem[i].free)
        this.dialog.MPercent.push(this.tempList.mem[i].percent)
        this.dialog.Mtotal.push(this.tempList.mem[i].total)
        this.dialog.Mused.push(this.tempList.mem[i].used)
      }
      this.optionPercent.xAxis.data = this.dialog.date
      this.optionPower.xAxis.data = this.dialog.date
      this.optionFanSpeed.xAxis.data = this.dialog.date
      this.optionPercent.series.data = this.dialog.percent
      this.optionPower.series.data = this.dialog.power
      this.optionFanSpeed.series.data = this.dialog.fanspeed

      this.optionMfree.xAxis.data = this.dialog.date
      this.optionMPercent.xAxis.data = this.dialog.date
      this.optionMused.xAxis.data = this.dialog.date
      this.optionMfree.series.data = this.dialog.Mfree
      this.optionMPercent.series.data = this.dialog.MPercent
      this.optionMused.series.data = this.dialog.Mused

      // console.log(this.optionFanSpeed.series.data)

      this.myChartFanSpeed.setOption(this.optionFanSpeed)
      this.myChartPercent.setOption(this.optionPercent)
      this.myChartPower.setOption(this.optionPower)
      this.myChartMfree.setOption(this.optionMfree)
      this.myChartMPercent.setOption(this.optionMPercent)
      this.myChartMused.setOption(this.optionMused)
    },
    initCharts () {
      this.myChartFanSpeed = echarts.init(document.getElementById('card-1'))
      // this.myChartFanSpeed.setOption(this.optionFanSpeed)
      this.myChartPercent = echarts.init(document.getElementById('card-2'))
      // this.myChartPercent.setOption(this.optionPercent)
      this.myChartPower = echarts.init(document.getElementById('card-3'))
      // this.myChartPower.setOption(this.optionPower)
      this.myChartMfree = echarts.init(document.getElementById('card-4'))
      this.myChartMPercent = echarts.init(document.getElementById('card-5'))
      this.myChartMused = echarts.init(document.getElementById('card-6'))
      this.postChart()
    },
    async changeFanSpeedByNum (num) {
      console.log({ userIp: this.activeIP, speed: num })
      const { data: res } = await this.$http.post('changeSpeed', { userIp: this.activeIP, speed: num })
      console.log(res)
      if (res.code === 200) this.$message.success('更改成功')
      else this.$message.error('更改失败')
    },
    async changeFanSpeedByChosedSpeed () {
      console.log(`speed?userIp=${this.activeIP}&speed=${this.chosedSpeed}`)
      if (this.chosedSpeed < 0 || this.chosedSpeed > 255 || !this.chosedSpeed) {
        this.$message.error('更改失败，转速要在0-255之内！')
      } else {
        const { data: res } = await this.$http.post(`speed?userIp=${this.activeIP}&speed=${this.chosedSpeed}`)
        console.log(res)
        if (res === '') this.$message.success('更改成功')
        else this.$message.error('更改失败')
      }
    }

  },
  mounted () {

  },
  created () {
    this.frameId = window.sessionStorage.getItem('activePath')
    this.getCard()
    setInterval(this.getCard, 2000)
    this.getIpList()
  },
  components: { TempCharts2, TempCharts }
}
</script>

<style scoped>
.container {
  min-width: 1200px;
  width: 100%;
  /* background-color: gray; */
}
.header {
  font-size: 25px;
  padding: 25px;
  text-align: center;
}
.topcards {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  padding: 25px;
}
.topcard {
  width: 300px;
  height: 150px;
  background-color: #fff;
  border-radius: 10px;
  margin: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* display: flex;
  justify-content: center;
  align-items: center; */
  padding: 20px;
}
.topcard-title {
  width: 100%;
  border-bottom: 1px solid gray;
}
.topcard-content {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 20px;
}
.topcard-content .card-icon img {
  width: 50%;
}
.card-icon-font {
  font-size: 50px;
  color: #1890ff;
}
.charts-container {
  display: flex;
  /* justify-content: space-around; */
  flex-wrap: wrap;
  padding: 20px;
  width: 100%;
}
.charts-container .chart {
  width: 46%;
  height: 400px;
  /* background-color: lightblue; */
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  margin-left: 45px;
}
.charts-container .chart .topcard-title {
  display: flex;
  justify-content: space-between;
}
.charts-container .chart .topcard-title .buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-1 {
  display: flex;
  /* align-items: start; */
}
.chart-item {
  width: 100%;
  height: 400px;
}
.dialog-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.dialog-chart {
  margin: 20px;
  width: 460px;
  height: 400px;
}
.dialog-card {
  height: 400px;
}
.card- {
  width: 460px;
  height: 400px;
}
.dialog1 /deep/.el-dialog__body {
  padding: 0 !important;
  background-color: red;
}
.el-button {
  margin-left: 20px;
  margin-bottom: 20px;
}
</style>
